module.exports = __webpack_public_path__ + "static/media/loader.a0c1683c.svg";